import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              A landscape is a mosaic of heterogeneous ecosystem elements with
              dynamic components of biotic and abiotic features, which governs
              the landscape's health. Land cover (LC) depicts the natural cover
              on the earth's surface, whereas land use (LU) indicates
              anthropogenic usage of the land, and assessment of these variables
              aid in understanding the landscape and interactions (Twisa and
              Buchroithner, 2019). The rise in anthropogenic activities
              including enhanced carbon emissions, has been altering the
              landscape's natural processes, biogeoclimatic interactions,
              hydrological regime, and global climatic alterations (Bharath et
              al., 2013; Vinay et al., 2013; Ramachandra et al., 2018a; Birhane
              et al., 2019; Tang et al., 2021). The unconstrained land use land
              cover (LULC) changes induce various ecological imbalances such as
              fragmentation, loss of resource availability, and interrupted
              environmental planning. Fragmentation is a devastating phenomenon
              and a conservation challenge that affects habitat integrity
              induced due to LULC changes in the form of various development
              projects, the creation of linear corridors, the various
              infrastructure developments, the establishment of industrial
              parks, and overexploitation resources. Fragmentation of forests
              contributes to discontinued forest patches of varying sizes, boost
              biodiversity loss and connectivity, enhances the forest
              communities' vulnerability, creates a microclimatic environmental
              gradient, and stimulates invasive species (Tripathi et al., 2010;
              Ramachandra et al., 2016; Galiatsatos et al., 2020). Assessing
              LULC changes induced fragmentation helps in addressing habitat
              isolation and edge effects on the forest patches (Laurance et al.,
              2007; Mengist et al., 2022).
            </p>
            <p>
              LULC estimation at a temporal scale forms a base for researchers,
              policymakers, and planners to determine natural resource
              availability, frame suitable policies, and evaluate growth
              patterns (Lambin, 2001; Reddy et al., 2019). Estimating LULC
              change has become a crucial strategy for monitoring environmental
              alterations to manage natural resources, , with the sustainable
              planning (Bharath and Ramachandra, 2021a). Geoinformatics offer
              consistent remote sensing (RS) data and essential, powerful GIS
              tools for determining LULC changes at different spatial scales.
              Spatial metrics, also popularly known as landscape metrics, are
              other measures that aid in elucidating the landscape's health,
              with insights of spatial pattern, connectivity, and the effects of
              human activities on processes (Uuemaa et al., 2009; Kurnar, 2011;
              Mairota et al., 2013; Ramachandra et al., 2020). LULC mapping has
              proved to be a beneficial way to assess, advance the choosing
              areas for different uses, and facilitate accounting for the
              leading causes and their environmental costs. However, forecasting
              probable alterations is crucial, especially in developing
              countries, where the resource bases, such as land, forest, and
              water, are declining significantly. Modeling and geo-visualization
              have become crucial for landscape management, assessing probable
              anthropogenic-induced changes (Bharath and Ramachandra, 2021b) and
              their adverse ecological consequences (Zeng et al., 2022).
              Modeling assistance in evaluating various conditions for
              sustainable development, accounting for appropriate spatial
              patterns of future LU, and aid as a decision support system (DSS)
              for regional planners and decision-makers (Ramachandra et al.,
              2017). It also helps empirically interpret the spatial changes and
              lends the strategies necessitated for landscape conservation
              through ecosystem protection. The scientific community has devised
              numerous models that employ statistical (Harris et al., 2017) and
              geospatial approaches to understand the landscape dynamics,
              drivers, and predict likely LU (Rosa et al., 2013). Well-known
              predictive LU models are logistic regression models (Das and
              Pandey, 2019), spatial-dynamic model (Cai et al., 2020),
              statistical concept-based models CLUE-S (Zhu et al., 2020), hybrid
              models-Fuzzy, Analytical Hierarchical Process (AHP), stochastic
              techniques such as spatial Markov chains (MC) (Behera et al.,
              2012), cellular automata (CA) (Sant&eacute; et al., 2010; Bharath
              et al., 2014; Zhang and Xia, 2022), DYNAMICA-EGO (Wu et al.,
              2017), and multi-criteria decision making (MCDM) techniques
              (Verburg et al., 2004; Ramachandra et al., 2017; Das and Pal,
              2020; Bharath et al., 2021). The continued increase in LULC
              changes and per capita resource utilization has resulted in
              unsustainable landscape exploitation, which signifies the
              necessity for conservation and the preservation of ecosystem
              processes for human existence.
            </p>
            <p>
              Ecologically sensitive regions (ESR) or ecologically fragile zones
              (EFZ) are diverse regions with distinguishing biotic and abiotic
              groups, which might need to be preserved from further degradation.
              ESR delineation involves integrating the information of proxy
              variables of the landscape, such as land, ecology, energy, and
              social aspects, which stimulates conservation and sustainable
              management. ESR framework recognizes the significance of
              ecological, geo-climatic, and social factors available in a region
              and prioritizes them into distinct units for conservation
              (Ramachandra et al., 2018b). In this regard, objectives of the
              current research are to (i) examine the spatiotemporal LULC
              transitions from 1989 to 2019; (ii) assessment of landscape health
              through forest fragmentation and spatial metrics; (iii)
              prioritization of ESRs based on their ecological significance;
              (iv) modeling the likely LU and suggest appropriate policy
              measures.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
